import rangeRight from 'lodash/rangeRight';

const DEFAULT_ACCOUNT_TYPE = 'FLAVOUR';
const DEFAULT_VOLUME = 'MEDIUM';

const ledgerAccountCategories = [
  { id: '1', name: 'Assets' },
  { id: '3', name: 'Liabilities' },
  { id: '5', name: 'Equity' },
  { id: '6', name: 'Revenues' },
  { id: '7', name: 'Operating Expenses' },
  { id: '8', name: 'Cost of Sales' },
];

const collectionMethods = [
  'Plaid',
  '3rd Party Login',
  'Shopify',
  'Gusto',
  'Square',
  'Other Integration',
  'Not Required',
  'Cannot Optimize',
  'Requested',
];

const optimizedStatus = 'Optimized';

const optimizationOptions = [
  optimizedStatus,
  'Cannot Optimize',
  'Not Optimized',
  'Not Available',
  'Opt Out',
];

const volumeOptions = [
  { id: 'LOW', label: 'Low' },
  { id: 'MEDIUM', label: 'Medium' },
  { id: 'HIGH', label: 'High' },
  { id: 'VERY_HIGH', label: 'Very High' },
  { id: 'NOT_APPLICABLE', label: 'N/A' },
];

const thirdPartyLoginStatus = {
  AVAILABLE: 'Available',
  UNAVAILABLE: 'Unavailable',
};

export const thirdPartyLoginOptions = [
  { id: thirdPartyLoginStatus.AVAILABLE, label: thirdPartyLoginStatus.AVAILABLE },
  { id: thirdPartyLoginStatus.UNAVAILABLE, label: thirdPartyLoginStatus.UNAVAILABLE },
];

const formatWithOrdinal = day => {
  if (day > 3 && day < 21) return `${day}th`;
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
};

const monthOptions = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
].map((label, index) => {
  const value = `0${index + 1}`.slice(-2);
  return { label, id: value };
});

const yearOptions = () => {
  const date = new Date();
  const currentYear = date.getFullYear();
  const firstActiveYear = 2000;

  // TODO what is isHistoric? This logic is copied from editLedgerCtrl
  // if (isHistoric) {
  //   return range(currentYear, currentYear - 14);
  // }

  return rangeRight(firstActiveYear, currentYear + 7).map(year => {
    const stringYear = year.toString();
    return { id: stringYear, label: stringYear };
  });
};

const getAccountsForConnections = connections =>
  connections.reduce(
    (accounts, connection) =>
      accounts.concat(
        connection.accounts.map(account => ({
          ...account,
          source: connection.source,
        })),
      ),
    [],
  );

const findFdsAccountByAccountId = (connections, accountId) => {
  if (connections?.length && accountId) {
    return getAccountsForConnections(connections).find(account => account?.id === accountId);
  }
};

const findFdsAccountByLedgerId = (connections, ledgerId) => {
  if (connections?.length && ledgerId) {
    return getAccountsForConnections(connections).find(
      account => account.ledger?.id === ledgerId.toString(),
    );
  }
};

export {
  DEFAULT_ACCOUNT_TYPE,
  DEFAULT_VOLUME,
  optimizedStatus,
  thirdPartyLoginStatus,
  collectionMethods,
  ledgerAccountCategories,
  optimizationOptions,
  volumeOptions,
  yearOptions,
  monthOptions,
  findFdsAccountByLedgerId,
  formatWithOrdinal,
  findFdsAccountByAccountId,
};
